<template>
  <v-app>
    <v-progress-linear
      :active="loading"
      :indeterminate="loading"
      absolute
      top
      fixed
      color="#97b699"
      height="10px"
    ></v-progress-linear>

    <nav>
      <v-app-bar style="background-color: white;" prominent app hide-on-scroll>
        <v-img @click="inicio" alt="Logo" class="logo" src="@/assets/logo-sin-propiedades.jpg"
          style="max-width:13rem; cursor: pointer;"></v-img>
        <v-spacer></v-spacer>
        <span class="alinear opciones" style="margin-top: 75px; margin-right: 16%;">
          <p style="color: #394c55; cursor: pointer;" class="mx-3" @click="inicio">Inicio</p>
          <p style="color: #394c55; cursor: pointer;" class="mx-3" @click="nosotros">Quiénes somos</p>
          <p style="color: #394c55; cursor: pointer;" class="mx-3" @click="venta">Venta</p>
        </span>
        <span class="menu mr-4">
          <v-icon class="mt-9 mr-4" x-large @click.stop="drawer = !drawer">mdi-menu</v-icon>
        </span>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          top
          fixed
          color="#97b699"
          height="10px"
        ></v-progress-linear>
      </v-app-bar>
    </nav>

    <v-navigation-drawer
      v-model="drawer"
      app
      left
      temporary
    >
      <v-list
        nav dense
      >
        <v-list-item-group
          class="ml-4 mt-4"
          active-class="deep-purple--text text--accent-4"
        >
          <v-list-item>
            <v-list-item-title @click="inicio">Inicio</v-list-item-title>
          </v-list-item>
          
          <v-list-item>
            <v-list-item-title @click="nosotros">Quiénes somos</v-list-item-title>
          </v-list-item>

          <v-list-item>
            <v-list-item-title @click="venta">Venta</v-list-item-title>
          </v-list-item>

          <v-list-item>
            <v-list-item-title @click=contacto>Contacto</v-list-item-title>
          </v-list-item>

        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <div class="sliderPc" align="center">
      <v-img
        style="max-width: 70%; height: 503px;"
        src="@/assets/bannerDk.jpg">
      </v-img>
    </div>
    <div class="sliderMobile" align="center">
      <v-img
        src="@/assets/bannerMb.jpg" >
      </v-img>
    </div>

    <hr color="#97b699">

    <div fluid class="mt-2 filtros">
      <h1 style="font-family: raleway;">Filtros</h1>
      <div class="alinear">
        <div class="mt-4 mr-4">
          <v-text-field class="codigo" color="#97b699" ref="codigo" dense label="Código" placeholder="Codigo" required v-model="codigo">
          </v-text-field>
        </div>
        <div>
          <v-select class="mx-4" color="#97b699" :items="items" label="Operación" v-model="operacion">
          </v-select>
        </div>
        <div>
          <v-select class="ml-2" color="#97b699" :items="prop" label="Propiedad" v-model="tipo">
          </v-select>
        </div>
      </div>
      <div class="alinear">
        <div>
          <v-combobox
            class="mr-4 mt-1 pt-0"
            placeholder="Calle"
            v-model="calle"
            :items="calles"
          ></v-combobox>
        </div>
        <div>
          <v-select class="mx-4 pt-0" color="#97b699" :items="ciudad" label="Localidad" v-model="localidad">
          </v-select>
        </div>
      </div>

      <div style="display: flex; justify-content: center;">
        <v-btn @click="filtrar" class="ml-4 mb-3" color="#97b699"  style="color: white; border-radius: 0.5rem; width: 20vh;">
          Filtrar</v-btn>
      </div>

    </div>
    <hr color="#97b699">
    <div align="center" class="py-5">
      <h1 style="font-family: raleway;">PROPIEDADES</h1>
    </div>

    <div align="center" v-show="loading" class="my-8">
      <v-progress-circular
        :size="70"
        :width="7"
        color="#97b699"
        indeterminate
      ></v-progress-circular>
    </div>

    <div v-for="(propiedad, i) in propiedades" :key="i">
      <PropiedadC :propiedad=propiedad></PropiedadC>
    </div>

    <div class="alinear my-6" style="justify-content:center;" v-show="paginado">
      <h3 class="mt-2">Página: </h3>
      <v-btn @click="colorPaginado(1), getProps(1)" 
        :color=pag1 style="color: black;" class="mx-5"> 1
      </v-btn>
      <v-btn @click="colorPaginado(2), getProps(2)" 
        :color=pag2 style="color: black;" light> 2
      </v-btn>
    </div>

    <!-- <v-card flat class="formulario" ref="formulario">
      <div class="alinear">
        <span class="ml-4">
          <h2 class="contactoTitulo">Contactanos</h2>
        </span>
        <v-spacer></v-spacer>
        <span class="mt-2 mr-4">
          <a :href=wpp target="_blank" style="text-decoration: none;">
            <v-btn class="white--text mx-auto" color="#97b699" style="border-radius: 0.5rem;">
              <v-icon>mdi-whatsapp</v-icon> 11-7605-2212
            </v-btn>
          </a>
        </span>
      </div>
      <form action="https://formsubmit.co/info@alfonsinagrandpropiedades.com.ar" method="POST">
        <v-text-field color="#97b699" name="nombre" dense label="Nombre" placeholder="Nombre y apellido" required
        style="margin:3% 5%">
        </v-text-field>
        <v-text-field color="#97b699" name="mail" dense label="Mail" placeholder="Mail" required
        style="margin:3% 5%">
        </v-text-field>
        <v-text-field color="#97b699" name="teléfono" dense label="Teléfono" placeholder="Teléfono" required
        style="margin:3% 5%">
        </v-text-field>
        <v-textarea autocomplete="mensaje" name="mensaje" label="Mensaje" style="margin:3% 5%" color="#97b699">
        </v-textarea>
        <v-row style="margin: 3% auto;">
          <v-btn type="submite" class="white--text mx-auto" color="#97b699" style="border-radius: 0.5rem;">Enviar</v-btn>
          <input type="hidden" name="_next" value="https://alfonsinagrandpropiedades.com.ar">
          <input type="hidden" name="_captcha" value="false">
        </v-row>
      </form>
      
    </v-card> -->

    <div class="piePagina" align="center">
      <a href="https://www.instagram.com/invites/contact/?i=sifpxfh5bktu&utm_content=p2mr61l" 
      target="_blank" style="text-decoration: none;">
        <v-btn class="icono" icon>
          <v-icon x-large class="white--text icono">mdi-instagram</v-icon>
        </v-btn>
      </a>
      <a href="https://www.facebook.com/AlfonsinaGrandPropiedades/" 
      target="_blank" style="text-decoration: none;">
        <v-btn class="icono" icon>
          <v-icon x-large class="white--text icono">mdi-facebook</v-icon>
        </v-btn>
      </a>
      
      <v-row justify="center" class="my-1" style="max-width: 100%;">
        <v-icon class="white--text mb-4 mr-2">mdi-email-outline</v-icon>
        <p class="mailMb" style="color: white;">info@alfonsinagrandpropiedades.com.ar</p>
      </v-row>
      <p style="color: grey;">Términos y condiciones | Política de privacidad</p>
      <div style="background-color: white;">
        <v-img src="@/assets/logo1.jpg" alt="logo" style="width: 20rem; border-radius: 100%;">
        </v-img>
      </div>
    </div>

    <v-dialog v-model="dialog" width="500px" height="180px">
      <v-card style="border-top: solid 10px #97b699;" width="500px" height="180px">
        <h3 style="padding: 0 50px; padding-top: 35px;">No se encontraron propiedades con esos filtros</h3>
        <div style=" padding-top: 2rem; width: 100%; display: flex; justify-content: space-around">
          <v-btn @click="cerrar">Aceptar</v-btn>
        </div>
      </v-card>
    </v-dialog>

    <!-- <v-dialog v-model="error" width="500px" height="180px">
      <v-card style="border-top: solid 10px red;" width="500px" height="180px">
        <h3 style="padding: 0 50px; padding-top: 35px;">Error de conección, recarge la pagina</h3>
        <div style=" padding-top: 2rem; width: 100%; display: flex; justify-content: space-around">
          <v-btn @click="cerrar">Aceptar</v-btn>
        </div>
      </v-card>
    </v-dialog> -->

  </v-app>
</template>

<script>
  import PropiedadC from '@/components/Propiedad/PropiedadC.vue'
  import db from '@/fb'
  import { collection, getDocs, query, where } from "firebase/firestore";

  export default {
    components: { PropiedadC },
    inject: {
      theme: {
        default: { isDark: false },
      },
    },
    data() {
      return {
        banner: [{src: '@/assets/logo1.jpg'}],
        items: ["Comprar", "Alquilar"],
        prop: ["Casa", "Departamento", "Terreno", "Campo", "Edificio"],
        calles: ["Pellegrini", "San Martin", "Madrid", "Tacuarí", "Álvarez Jonte", "El Facón", "Belgrano", "Sarmiento",
          "Independencia", "Zamudio", "Pueyrredón", 'Viamonte', 'Alemania', 'Vieytes', 'Sarmiento', 'Suipacha', 'San Martín' ],
        ciudad: ["Marcos Paz", "Las Heras"],
        wpp : 'https://wa.me/5491176052212',
        loading: false,
        codigo: '',
        localidad: '',
        calle: '',
        operacion: '',
        tipo: '',
        dialog: false,
        min: 0,
        max: 1000000,
        drawer: false,
        pag: 1,
        paginado: true,
        pag1: '#97b699',
        pag2: '#F8F8FF',

        propiedades: [],
      }
    },
    methods: {
      inicio() {
        this.drawer=false
        location. reload()
        window.scrollTo(0,0)
      },

      colorPaginado(pag){
        if(pag==1){
          this.pag1='#97b699'
          this.pag2='#F8F8FF'
        } else if (pag==2){
          this.pag1='#F8F8FF' 
          this.pag2='#97b699'
        }
      },
      contacto () {
        this.drawer=false
        this.$refs.formulario.$el.scrollIntoView({block: 'center', behavior: 'smooth'})
      },
      nosotros () {
        this.$router.push('/nosotros')
      },
      cerrar () {
        this.dialog = false
      },
      validarF () {
        if(this.propiedades.length==0){
          this.dialog = true
        }
      },

      /* validar () {
        if(this.propiedades.length==0){
          this.error = true
        }
      }, */

      async getProps (n) {
        this.loading = true
        this.pag = n
        this.propiedades = []
        this.paginado = true

        const q = query(collection(db, "propiedades"), 
        where('pagina', '==', this.pag))

        const res = await getDocs(q)
        res.forEach((doc) => {
          this.propiedades.push(doc.data())
        })
        this.loading = false
      },

      venta () {
        this.drawer = false
        window.scrollTo(0,700)
      },

      /* async venta () {
        this.drawer = false
        this.loading = true
        this.paginado = false

        const q = query(collection(db, "propiedades"), 
        where('comprar', '==', true))

        this.propiedades = []
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
          this.propiedades.push(doc.data())
        })

        this.loading = false
      }, */

      async lote () {
        this.drawer = false
        this.loading = true
        this.paginado = false

        const q = query(collection(db, "propiedades"), 
        where('tipo', '==', 'Terreno'))

        this.propiedades = []
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
          this.propiedades.push(doc.data())
        })

        this.loading = false
      },

      async filtrar () {
        this.loading = true
        this.paginado = false

        let codigoValor = true
        let fCodigo = 'filtro'
        let operacionValor = true
        let fOperacion = 'filtro'
        let tipoValor = true
        let fTipo = 'filtro'
        let calleValor = true
        let fCalle = 'filtro'
        let localidadValor = true
        let fLocalidad = 'filtro'

        if(this.codigo){
          codigoValor = this.codigo
          fCodigo = 'codigo'
        }
        if(this.localidad){
          localidadValor = this.localidad
          fLocalidad = 'localidad'
        }
        if(this.tipo){
          tipoValor = this.tipo
          fTipo =  'tipo'
        }
        if(this.calle){
          calleValor = this.calle.toLowerCase()
          fCalle = 'calle'
        }
        if(this.operacion){
          if(this.operacion=='Comprar'){
            fOperacion = 'comprar'
          }else if (this.operacion=='Alquilar') {
            fOperacion = 'alquilar'
          }
          operacionValor = true
        }

        const q = query(collection(db, "propiedades"), 
        where(fCodigo, '==', codigoValor), where(fLocalidad, '==', localidadValor),
        where(fTipo, '==', tipoValor), where(fCalle, '==', calleValor),
        where(fOperacion, '==', operacionValor))

        this.propiedades = []
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
          this.propiedades.push(doc.data())
        })

        console.log(querySnapshot)

        this.loading = false

        this.tipo = null
        this.codigo = null
        this.localidad = null
        this.calle = null
        this.operacion = null

        this.validarF()
      }
    },
    mounted() {
      this.getProps(1)
    }
}
</script>

<style>
  .logo{
    margin-left: 20px;
  }
  .menu{
    display: none;
  }
  .codigo{
    width: 13rem;
  }
  .alinear{
    display: flex;
    justify-content: flex-start;
  }
  .slider{
    width: 84vh;
    height: 48vh;
    max-height: 100%;
    border-radius: 1rem 0% 0% 1rem; 
    border-bottom: solid 12px #97b699;
  }
  .borde{
    border: solid; 
    border-color:#97b699; 
    height: 49vh; 
    border-radius:  0% 1rem 1rem 0%; 
    padding: 0%;
    padding-bottom: 3%;
  }
  .sliderPc{
    width: 100%;
    height: 80vh;
    margin: 0 auto;
    background-color: #394c55;
  }
  .sliderMobile{
    width: 100%;
    height: 80vh;
    margin: 0 auto;
    background-color: #394c55;
    display: none;
    margin-top: -50px;
  }
  .formulario{
    width: 90vh;
    margin: 2rem auto;
  }
  .piePagina{
    height: 380px;
    width: 100%;
    background-color: #394c55;
  }
  .icono{
    margin: 1rem 0.5rem;
  }
  .circulo{
    background-color: white;
    width: 30rem;
    height: 30rem;
    border-radius: 150%;
  }
  .filtros{
    margin: 0 auto;
  }
  .contactanos{
    margin-top: 52vh;
    border-radius: 2rem;
  }
  .texto{
    margin: auto 10%;
    font-family: Century Gothic;
  }
  .contactoTitulo{
    font-family: raleway; 
    font-size: xx-large;
  }

  @media screen and (max-width: 870px) {
    .menu{
      display: block;
    }
    .opciones{
      display: none;
    }
    .piePagina{
      height: 300px;
    }
  }

  @media screen and (max-width: 700px) {
    .sliderPc{
      display: none;
    }
    .sliderMobile{
      display: block;
    }
    .codigo{
      width: auto;
    }
    .texto {
      font-size: small;
    }
    .borde{
      border-radius:  0% 0% 1rem 1rem; 
      height: 40vh;
    }
    .slider{
      border-radius: 1rem 1rem 0% 0%; 
      height: 100%;
    }
    .filtros{
      margin: 0 5%;
    }
    .imagen{
      background-image: url(@/assets/bannerMb.jpg);
    }
    .logo{
      margin-left: 0;
    }
  }
  @media screen and (max-width: 320px) {
    .contactoTitulo{
      font-size: larger;
      margin-top: 15px;
    }
    .mailMb{
      font-size: smaller;
      margin-top: 3px;
    }
  }
</style>